import {
  SnackbarComponent
} from "./chunk-T4ZDXQCO.mjs";
import {
  snackbarStore
} from "./chunk-DWJYOFCM.mjs";
import {
  getSnackbarListStyle
} from "./chunk-6FDAA7GW.mjs";

// src/snackbar.provider.tsx
import { useSyncExternalStore } from "react";
import { AnimatePresence } from "framer-motion";
import { Portal } from "@clara/portal";
import { createContext } from "@clara/react-utils";
import { jsx } from "react/jsx-runtime";
var [SnackbarOptionProvider, useSnackbarOptionContext] = createContext({
  name: `SnackbarOptionsContext`,
  strict: false
});
var SnackbarProvider = (props) => {
  const state = useSyncExternalStore(
    snackbarStore.subscribe,
    snackbarStore.getState,
    snackbarStore.getState
  );
  const {
    motionVariants,
    component: Component = SnackbarComponent,
    ...portalProps
  } = props;
  const stateKeys = Object.keys(state);
  const snackbarList = stateKeys.map((position) => {
    const snackbars = state[position];
    return /* @__PURE__ */ jsx(
      "div",
      {
        role: "region",
        "aria-live": "polite",
        "aria-label": `Notifications-${position}`,
        id: `ui-snackbar-manager-${position}`,
        style: getSnackbarListStyle(position),
        children: /* @__PURE__ */ jsx(AnimatePresence, { initial: false, children: snackbars.map((snackbar) => /* @__PURE__ */ jsx(
          Component,
          {
            motionVariants: typeof snackbar.status === "undefined" && snackbar.duration === null ? {} : motionVariants,
            ...snackbar
          },
          snackbar.id
        )) })
      },
      position
    );
  });
  return /* @__PURE__ */ jsx(Portal, { ...portalProps, children: snackbarList });
};

export {
  SnackbarOptionProvider,
  useSnackbarOptionContext,
  SnackbarProvider
};
